<template>
	<cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
		ref="table">
	</cTable>
</template>

<script>
	import {
		getDetails,
		setException,
		removeDetail
	} from "@/api/finance/dduBill";
	import cTable from "@/base/common/index";
	import {
		getCountry
	} from "@/api/system/country";
	import {
		getAllClient,
		getCompanies
	} from "@/api/user/client";
	import {
		getUser
	} from "@/api/user/internal";
	import {
		getAgent
	} from "@/api/tracker/agent";
	export default {
		name: "dduShipment",
		components: {
			cTable,
		},
		props: {
			row: {
				type: Object,
			},
		},
		data() {
			return {
				methods: {
					list: (params) => {
						params.id = this.row.id
						return getDetails(params)
					},
					setException,
					removeDetail
				},
				footer: {},
				config: {
					rows:this.row,
					slot: 'div',
					height: 630,
					contentMethod({
						row,
						column
					}) {
						if (column.type == "calculate_status" && row.calculate_msg) {
							return row.calculate_msg;
						}
					}
				},
				modals: {
					hang: {
					  methods: {
					    ok({ row, close }) {
					      let data = row;
					      data.ids = this.$page.selectAll.map((item) => item.id);
					      data.id = this.$page.config.rows.id;
					      this.$page.handleRequestMethods("setException", data).then((res) => {
					        this.$Message["success"]({
					          background: true,
					          content: res.msg,
					        });
					        this.$page.getList();
					        close();
					      });
					    },
					  },
					  config: {
					    modalBind: {
					      width: 600,
					      draggable: true,
					    },
					    formBind: {
					      labelWidth: 80,
					    },
					    rowBind: {
					      gutter: 16,
					      style: {
					        marginBottom: "20px",
					      },
					    },
					    rules: {
					      remarks: [
					        {
					          required: true,
					          message: "cannot be empty",
					          trigger: "blur",
					        },
					      ],
					    },
					  },
					  grid: [{ remarks: 24 }],
					  fields: [
					    {
					      name: () => this.$t("Remarks"),
					      key: "remarks",
					      component: "Input",
					      placeholder() {
					        return this.$t("enter") + this.$t("Remarks");
					      },
					      bind: {
					        type: "textarea",
					        rows: 5,
					      },
					    },
					  ],
					},
				},
				header: {
					searchs: [{
						key: "keywords",
						placeholder() {
							return this.$t("keyword");
						},
						bind: {
							style: "width:140px",
							type: "textarea",
							rows: 1
						},
						component: "Input"
					}],
					btns: {
						list: [

							{
								name: () => this.$t("export"),
								type: "export",
								fnName: "export",
								disabled() {
									return !this.selectAll.length;
								},
								bind: {
									icon: "md-arrow-down",
									type: "primary",
								},
							},
							{
							  name: this.$t("hang"),
							  type: "hang",
							  fnName: "hang",
							  bind: {
							    icon: "md-trash",
							    type: "error",
							  },
							  disabled() {
							    return (
							      !this.selectAll.length
							    );
							  },
							},
							{
							  name: this.$t("delete"),
							  type: "delete",
							  fnName: "delete",
							  bind: {
							    icon: "md-trash",
							    type: "error",
							  },
							  disabled() {
							    return (
							      !this.selectAll.length
							    );
							  },
							},
						],
						methods: {
							export () {
								this.exportExc();
							},
							hang() {
								this.getModal("hang").open({}, function () {
									this.setTitle(this.$t("hang"));
								});
							},
							delete() {
								this.$Modal.confirm({
									title: this.$t("whether") + this.$t("delete"),
									width: 300,
									content: this.$t("titleModal"),
									onOk: () => {
										let data = {
											id: this.config.rows.id,
											ids: this.selectAll.map((item) => {
												return item.id;
											}),
										};
										this.handleRequestMethods("removeDetail", data).then(
											(res) => {
												this.$Message["success"]({
													background: true,
													content: res.msg,
												});
												this.getList();
											}
										);
									},
								});
							},
						},
					},
				},
				fields: [{
						type: "checkbox",
						align: "center",
						width: 60,
					},
					{
						name: () => this.$t("Odd_Numbers"),
						key: "airway_bill_number",
						minWidth: 130,
					},
					{
						name: () => this.$t("outbound_time"),
						key: "outbound_time",
						minWidth: 130,
					},
					{
						name: () => this.$t("agentT"),
						key: "deliver",
						minWidth: 130,
					},
					{
						name: () => this.$t("order_refCode"),
						key: "agent_refer_code",
						minWidth: 130,
					},
					{
						name: () => this.$t("b2bClient"),
						key: "client_account",
						minWidth: 130,
					},
					{
						name: () => this.$t("salesman"),
						key: "salesman_account",
						minWidth: 130,
					},
					{
						name: () => this.$t("ownership"),
						key: "ownership_name",
						minWidth: 130,
					},
					{
						name: () => this.$t("shipperRef"),
						key: "client_refer_code",
						minWidth: 130,
					},
					{
						name: () => this.$t("channel_code"),
						key: "transport_mode",
						minWidth: 130,
					},
					{
						name: () => this.$t("country_t"),
						children: [{
								name: () => this.$t("allow_depart"),
								key: "from_country",
								minWidth: 100,
							},
							{
								name: () => this.$t("allow_arrive"),
								key: "to_country",
								minWidth: 100,
							},
							{
								name: () => this.$t("city_t"),
								key: "city_name",
								minWidth: 100,
							},
						],
					},
					{
						name: () => this.$t("trajectory"),
						children: [{
								name: () => this.$t("tracker_code"),
								key: "trace_status",
								minWidth: 100,
							},
							{
								name: () => this.$t("track_title"),
								key: "trace_remarks",
								minWidth: 100,
							},
							{
								name: () => this.$t("tracker_time"),
								key: "trace_time",
								minWidth: 100,
							},
						],
					},
					{
						name: () => this.$t("DeclaredValue"),
						key: "values",
						minWidth: 100,
					},
					{
						name: () => this.$t("invoiceWeight"),
						children: [{
								name: () => this.$t("actual_weight"),
								key: "check_weight",
								minWidth: 100,
							},
							{
								name: () => this.$t("charge_volume"),
								key: "charge_volume",
								minWidth: 100,
							},
							{
								name: () => this.$t("charge_params"),
								key: "charge_weight",
								minWidth: 100,
							},
						],
					},
					{
						name: () => this.$t("cost_t"),
						children: [{
								name: () => this.$t("Bayan"),
								key: "bayan_fee",
								minWidth: 100,
							},
							{
								name: () => this.$t("Bank"),
								key: "bank_fee",
								minWidth: 100,
							},
							{
							  name: () => this.$t("Legalization"),
							  key: "legalization_fee",
							  minWidth: 100,
							},
							{
							  name: () => this.$t("Nas handle"),
							  key: "nas_handle_fee",
							  minWidth: 100,
							},
							{
							  name: () => this.$t("Global"),
							  key: "global_fee",
							  minWidth: 100,
							},
							
							{
							  name: () => this.$t("insurance_fee"),
							  key: "insurance_fee",
							  minWidth: 100,
							},
							{
							  name: () => this.$t("tax_fee"),
							  key: "duty_fee",
							  minWidth: 100,
							},
							{
							  name: () => this.$t("VATFee"),
							  key: "vat_fee",
							  minWidth: 100,
							},
							{
							  name: () => this.$t("document_fee"),
							  key: "paper_fee",
							  minWidth: 100,
							},
							{
							  name: () => this.$t("clearanceFee"),
							  key: "clearance_fee",
							  minWidth: 100,
							},
							{
								name: () => this.$t("totalFee"),
								key: "total_fee",
								minWidth: 100,
							},
							{
								name: () => this.$t("currencyCode"),
								key: "origin_currency",
								minWidth: 100,
							},
						],
					},
					
				],
			};
		},
		async mounted() {
			let fromCountry = (await getCountry({
				allow_depart: 1
			})).data.payload.rows;
			let toCountry = (await getCountry({
				allow_arrive: 1
			})).data.payload.rows;
			let client = (await getAllClient()).data.payload.rows;
			let salesman = (await getUser({
				standard: "Salesman"
			})).data.payload.rows;
			let companiesList = (await getCompanies()).data.payload;
			let agent = (await getAgent()).data.payload.rows;
			this.header.searchs.forEach(async (item) => {
				if (item.key === "from_country") item.options = fromCountry;
				if (item.key === "to_country") item.options = toCountry;
				if (item.key === "client_id") item.options = client;
				if (item.key === "salesman_id") item.options = salesman;
				if (item.key === "ownership") item.options = companiesList;
				if (item.key === "deliver") item.options = agent;
			});
		},
	};
</script>
